import { render, staticRenderFns } from "./JdsAvatarStack.vue?vue&type=template&id=75366be2&"
import script from "./JdsAvatarStack.vue?vue&type=script&lang=ts&"
export * from "./JdsAvatarStack.vue?vue&type=script&lang=ts&"
import style0 from "./JdsAvatarStack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports